import React from 'react';
import * as yup from 'yup';

import CrudPage from '@modules/cruds/CrudPage';
import { defaultConfigComponent } from './Categories';
import CategoryForm from './CategoryForm';

const categorySchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const CategoryPage = props => {
  return (
    <CrudPage
      key={'categoryPage'}
      configComponent={defaultConfigComponent}
      form={CategoryForm}
      validationSchema={categorySchema}
    />
  );
};

export default CategoryPage;
